import { ProgrammaShell } from "@/client/components/school-portal/ProgrammaShell";
import { MaatwerkSection } from "@/client/components/school-portal/sections/MaatwerkSection";
import { DeskundigheidsbevorderingSection } from "@/client/components/school-portal/sections/DeskundigheidsbevorderingSection";
import { ProgrammaReviewSection } from "@/client/components/school-portal/sections/ProgrammaReviewSection";
import { VastKeuzeSection } from "@/client/components/school-portal/sections/VastKeuzeSection";
import { TechnoHubSection } from "@/client/components/school-portal/sections/TechnoHubSection";
import type { ProgrammaSectionCode } from "@/client/components/school-portal/portal-flow";

// Vast- & keuzeprogramma is the per-group SUBNAV TREE + autosave UI (VastKeuzeSection): it publishes
// its groups to the shell's left-stepper sub-nav, renders the active group's vast/keuze in the right
// pane, and autosaves each pick. TechnoHub is now WORKSHOP-CENTRIC (TechnoHubSection): one card per
// workshop with the school's eligible groups as aanvinkbare chips, autosaving the per-group
// technohub selection. It publishes an EMPTY sub-nav, so the shell shows it as a single step.
function renderSection(code: ProgrammaSectionCode, schoolId: number) {
  switch (code) {
    case "vast_keuze":
      return <VastKeuzeSection schoolId={schoolId} />;
    case "technohub":
      return <TechnoHubSection schoolId={schoolId} />;
    case "deskundigheidsbevordering":
      return <DeskundigheidsbevorderingSection schoolId={schoolId} />;
    case "maatwerk":
      return <MaatwerkSection schoolId={schoolId} />;
    case "programma_controleren":
      return <ProgrammaReviewSection schoolId={schoolId} />;
  }
}

export function ProgrammaPage() {
  return <ProgrammaShell renderSection={renderSection} />;
}
